import type { Component } from 'vue';
import { defineAsyncComponent } from 'vue';
import {
  isLauncherTheme,
  type LauncherTheme,
} from '@features/tenant/launcherTheme';

type ShellLoader = () => Component;

const shell = (loader: () => Promise<unknown>): ShellLoader => {
  const component = defineAsyncComponent(
    loader as () => Promise<{ default: Component }>,
  );
  return () => component;
};

export const APP_SHELLS: Partial<Record<LauncherTheme, ShellLoader>> & {
  minimal: ShellLoader;
} = {
  minimal: shell(() => import('@shared/ui/minimal/MinimalAppShell.vue')),
  arena: shell(() => import('@shared/ui/arena/ArenaAppShell.vue')),
  modern: shell(() => import('@shared/ui/modern/ModernAppShell.vue')),
};

export const resolveAppShell = (theme: LauncherTheme): ShellLoader => {
  const own = isLauncherTheme(theme) ? APP_SHELLS[theme] : undefined;
  return own ?? APP_SHELLS.minimal;
};
